// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"ca476b0a","268":"a1ec937a","328":"4f8e61b5","416":"02112770","434":"8ffe392f","561":"d87b3bbe","676":"564567b4"}[chunkId] + ".chunk.js";
};